import React from 'react';
import { useLocation, Navigate, Outlet } from 'react-router';
import { useAppSelector } from '../store/hooks';

interface RequireAuthProps {
  allowedRoles: string[];
}

const RequireAuth: React.FC<RequireAuthProps> = ({ allowedRoles }) => {
  const user = useAppSelector((state) => state.auth?.user);
  const location = useLocation();

  const hasPermission = user?.privileges?.some((role) =>
    allowedRoles.some((allowRole) => allowRole === role.type && role.privilege)
  );

  if (hasPermission) {
    return <Outlet />;
  }

  if (user?.id) {
    return <Navigate to="/unauthorized" state={{ from: location }} replace />;
  }

  return <Navigate to="/login" state={{ from: location }} replace />;
};

export default RequireAuth;
